import { render, staticRenderFns } from "./nice-fail.vue?vue&type=template&id=2780b729"
import script from "./nice-fail.vue?vue&type=script&lang=js"
export * from "./nice-fail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports